import styled from 'styled-components';
import Slider from 'react-slick';
import { MDBDropdown, MDBDropdownMenu, MDBDropdownItem } from 'mdbreact';
import { colors, MediaQuery } from '../../../theme/style-helpers';
import { MDBDropdownToggle } from '../../../components/_styledComponents/MDBDropdownToggle';

export const WidgetContainer = styled.div`
    background: ${(props) => ((props.type === 'fluid') ? colors.GREY_LIGHTEST : colors.WHITE)};
    box-sizing: border-box;
    margin-bottom: ${(props) => ((props.type === 'fluid') ? '0' : '48px')};
    font-size: 1.4rem;
    border-bottom: ${colors.GREY_LIGHT} 4px solid;
    padding:  ${(props) => ((props.type === 'fluid') ? '48px 0px' : '0')};

    .wrapper{
      max-width: 1320px;
      margin: 0 auto;
      padding: ${(props) => ((props.type === 'fluid') ? '0 20px' : '0')};
    }

    ${MediaQuery.small`
        padding:  ${(props) => ((props.type === 'fluid') ? '72px 60px' : '0')};
    `};
`;

export const WidgetHeader = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;
`;

export const WidgetTitle = styled.h3`
    font-size: 1.8rem;
    font-family: Montserrat;
    font-weight: 600;
`;

export const WidgetToolbar = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`;

export const WidgetTableContainer = styled.div`
    position: relative;
    min-height: 250px;
    padding: 0;
`;

export const StyledMDBDropdown = styled(MDBDropdown)`
  .dropdown-menu {
    padding: 24px;
    background-color: ${colors.LIGHT_GREY} !important;
    cursor: default;

    >div {
      display: grid;
      grid-gap: 24px;
    }
  }
`;

export const StyledMDBDropdownToggle = styled(MDBDropdownToggle)`
  display: grid !important;
  grid-gap: 8px;
  grid-auto-flow: column;
  justify-content: center;
  align-items: center;

  span {
    color: ${colors.BLACK};
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    letter-spacing: 0em;
  }
`;

export const DropdownItem = styled(MDBDropdownItem)`
  display: flex !important;
  align-items: center !important;
  padding: 0px !important;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  letter-spacing: 0em;
  cursor: pointer;
  color: ${colors.BLACK};

  &:disabled {
    color: ${colors.DARK_GREY} !important;
  }

  &:hover {
    background-color: ${colors.BRAND_ORANGE} !important;
  }
`;

export const DropdownItemIcon = styled.div`
  width: 20px;
  height: 20px;
  background: url( ${({ iconSrc }) => iconSrc});
  background-size: 16px 16px;
  background-repeat: no-repeat;
  margin: 0;
  margin-right: 8px;
`;

export const StyledMDBDropdownMenu = styled(MDBDropdownMenu)`
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    min-width:300px !important;
  }
`;

export const ResultsFeedbackWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 250px;
  background-color: ${colors.GREY_LIGHTEST};

  p {
    font-family: Montserrat;
    font-weight: 600;
  }
`;

export const ButtonsWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

// REACT SLICK SLIDER STYLES
export const WidgetSliderMobile = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 16px;
  overflow-x: auto;
  margin-bottom: 48px;

  .slide {
    min-width: 292px;

    &:first-child {
      padding-left: 20px;
    }

    &:last-child {
      padding-right: 20px;
    }
  }

`;

export const WidgetSlider = styled(Slider)`
  margin-bottom: 48px;

  .slick-list {
    margin: 0 -12px;
  } 

  .slick-arrow {
    display: flex !important;
    top: 50%;
    width: 40px;
    height: 40px;
    margin-top: -20px;
    background-color: ${colors.WHITE};
    box-shadow: rgba(0,0,0,0.1) 0px 2px 8px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;

    &.slick-next {
      right: -50px;

      .icon {
        path {
          fill: ${colors.BLACK};
        }
      }

      &:hover {
        .icon path {
          fill: ${colors.BRAND_ORANGE};
        }
      }
    }

    &.slick-prev {
      left: -50px;

      .icon {
        transform: rotate(180deg);

        path {
          fill: ${colors.BLACK};
        }
      }

      &:hover {
        .icon path {
          fill: ${colors.BRAND_ORANGE};
        }
      }
    }

    &:before {
      content: none;
    }
  }
`;

export const StyledSlide = styled.div`
  position: relative;
  padding: 0 12px;

    a,
    a:hover,
    a:active,
    a:visited {
      text-decoration: none;
    }

    .slide-image {
      height: 200px;
      background-size: cover;
      background-position: center center;
      margin-bottom: 20px;
    }

    .slide-title {
      font-family: Montserrat;
      font-weight: 400;
      font-size: 1.8rem;
      line-height: 2.7rem;
      color: ${colors.BLACK};
    }
`;
